import { jsonify, sanitize } from "../TapiocaUtils";
export default class BridgeClient {
  constructor(raw) {
    this.raw = raw;
  }
  batchDelete(body) {
    const url = "/v1/automations:batch-delete";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * This endpoint performs cleanup related to a completed file package
   */
  completeFilePackage(body) {
    const url = "/v1/file_package";
    return this.raw.patch(url, jsonify(body));
  }
  /**
   * This endpoint creates a bridge based on an existing bridge request.
   */
  createBridge(body) {
    const url = "/v1/bridges";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * This endpoint deletes an active bridge.
   */
  deleteBridge(bridgeId, params) {
    const url = {
      url: `/v1/bridges/${bridgeId}`,
      params: sanitize(params || {}),
    };
    return this.raw.delete(url);
  }
  deleteProjectAutomations(sourceProjectUid, target, params) {
    const url = {
      url: `/v1/automations/${sourceProjectUid}/${target}`,
      params: sanitize(params || {}, { asset_types: "csv" }),
    };
    return this.raw.delete(url);
  }
  /**
   * This endpoint records the assets requested by the current user
   * and returns an identifier for the record.
   */
  filePackageAccept(body) {
    const url = "/v1/transaction";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * This endpoint records the assets requested by the current user into
   * an existing record.
   */
  filePackageAcceptAddAssets(transactionId, body) {
    const url = `/v1/transaction/${transactionId}`;
    return this.raw.post(url, jsonify(body));
  }
  /**
   * This endpoint will add assets to an existing file package.
   */
  filePackageAddAssets(filePackageId, body) {
    const url = `/v1/file-package/${filePackageId}`;
    return this.raw.post(url, jsonify(body));
  }
  /**
   * This endpoint will create a file package and return its identifier.
   */
  filePackageCreate(body) {
    const url = "/v1/file-package";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * This endpoint fetches information about a bridge request.
   */
  getBridgeRequest(bridgeRequestId) {
    const url = `/v1/bridge-requests/${bridgeRequestId}`;
    return this.raw.get(url);
  }
  /**
   * Gets a list of neigboring projects for the source project of a bridge request
   */
  getBridgeRequestNeighbors(bridgeRequestId, params) {
    const url = {
      url: `/v1/bridge-requests/${bridgeRequestId}/sender-neighbors`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  /**
   * This endpoint fetches bridge requests for a given project.
   */
  getBridgeRequests(params) {
    const url = {
      url: "/v1/bridge-requests",
      params: sanitize(params || {}, { "filter[status]": "csv" }),
    };
    return this.raw.get(url);
  }
  /**
   * This endpoint fetches bridges for a given project.
   */
  getProjectBridges(params) {
    const url = {
      url: "/v1/bridges",
      params: sanitize(params || {}, { "filter[status]": "csv" }),
    };
    return this.raw.get(url);
  }
  getReceivedTransaction(transactionId) {
    const url = `/v1/transaction/received_transaction/${transactionId}`;
    return this.raw.get(url);
  }
  getReceivedTransactionAssets(transactionId, params) {
    const url = {
      url: `/v1/received_transaction/${transactionId}/assets`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  /**
   * This endpoint records the assets requested by the current user into
   * an existing record.
   */
  getReceivedTransactions(projectId, params) {
    const url = {
      url: `/v1/project/${projectId}/received_transactions`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  /**
   * This endpoint fetches a single sent transaction based on its unique identifier.
   */
  getSentTransaction(transactionId) {
    const url = `/v1/transaction/sent_transaction/${transactionId}`;
    return this.raw.get(url);
  }
  /**
   * This endpoint records the assets requested by the current user into
   * an existing record.
   */
  getSentTransactions(projectId, params) {
    const url = {
      url: `/v1/project/${projectId}/sent_transactions`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  getSentTransactionsAssets(transactionId, params) {
    const url = {
      url: `/v1/sent_transaction/${transactionId}/assets`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  queryAutomations(params) {
    const url = {
      url: "/v1/automations",
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  queryNetwork(projectId, params) {
    const url = {
      url: `/v1/automations/neighbors/${projectId}`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  /**
   * This endpoint creates a bridge request.
   */
  requestBridge(body) {
    const url = "/v1/bridge-requests";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * This endpoint resends a pending bridge request.
   */
  resendBridgeRequest(bridgeRequestId) {
    const url = `/v1/bridge-requests/${bridgeRequestId}/resend`;
    return this.raw.get(url);
  }
  /**
   * This endpoint withdraws a bridge request.
   */
  withdrawBridgeRequest(bridgeRequestId) {
    const url = `/v1/bridge-requests/${bridgeRequestId}`;
    return this.raw.delete(url);
  }
}
